<template>
  <HeaderPages />
  <div v-if="loading" class="article_loading">
    <p class="font_1rem_400_Raleway color_violet">Загрузка...</p>
  </div>
  <template v-else-if="article">
    <section class="section_article">
      <div class="container_article_left">
        <div class="main_block_article">
          <p class="font_1rem_400_Raleway color_violet">{{ article.date }}</p>
          <h2 class="title_services_design">{{ article.title }}</h2>
          <img
            v-if="article.image"
            class="illustrations_articles"
            :src="`/article_illustrations/${article.image}`"
            alt="иллюстрация статьи"
          />
          <AutorMobile v-if="authors.length" :authors="authors" />
          <div class="article_body" v-html="article.html_content"></div>
        </div>
      </div>
      <ArticleRight v-if="authors.length" :authors="authors" />
    </section>
    <section class="section_article_bottom">
      <div class="container_article_bottom">
        <router-link to="/blog" class="box_back_article">
          <button class="button_back_article">
            <img
              src="@/assets/elements/arrow_left.svg"
              class="arrow_left_article"
              alt="стрелка"
            />
          </button>
          <p class="text_small_kreadon-bold color_violet">
            вернуться к списку статей
          </p>
        </router-link>
      </div>
    </section>
  </template>
  <div v-else class="article_loading">
    <p class="font_1rem_400_Raleway color_violet">Статья не найдена</p>
  </div>
  <FooterArticles />
</template>

<script>
import { useHead } from "@vueuse/head";
import { ref, computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import HeaderPages from "@/components/permanent/HeaderPages.vue";
import FooterArticles from "@/components/permanent/FooterArticles.vue";
import AutorMobile from "@/components/article/ui/AutorMobile.vue";
import ArticleRight from "@/components/article/ui/ArticleRight.vue";

export default {
  components: { HeaderPages, FooterArticles, AutorMobile, ArticleRight },
  setup() {
    const route = useRoute();
    const article = ref(null);
    const loading = ref(true);

    const authors = computed(() => {
      if (!article.value?.author_name) return [];
      return [{
        name: article.value.author_name,
        position: article.value.author_position || '',
        image: article.value.author_image
          ? `/autor/${article.value.author_image}`
          : '/autor/kirill.png',
      }];
    });

    useHead({
      title: computed(() => {
        if (article.value) return article.value.seo_title || article.value.title || "MTI-Dev";
        if (!loading.value) return "Страница не найдена — MTI-Dev";
        return "MTI-Dev";
      }),
      meta: computed(() => {
        if (!article.value && !loading.value) {
          return [
            { name: "description", content: "Запрошенная страница не найдена на сайте MTI-Dev." },
            { name: "robots", content: "noindex, nofollow" },
          ];
        }

        return [
          {
            name: "description",
            content:
              article.value?.seo_description ||
              article.value?.title ||
              "Статья MTI-Dev о разработке сайтов, дизайне, SEO и цифровых сервисах.",
          },
          { name: "robots", content: "index, follow" },
        ];
      }),
    });

    async function loadArticle(slug) {
      loading.value = true;
      article.value = null;
      try {
        const res = await fetch(`/api/articles/${slug}`);
        if (!res.ok) throw new Error('not found');
        article.value = await res.json();
      } catch {
        article.value = null;
      } finally {
        loading.value = false;
      }
    }

    onMounted(() => loadArticle(route.params.slug));
    watch(() => route.params.slug, (slug) => { if (slug) loadArticle(slug); });

    return { article, loading, authors };
  },
};
</script>

<style scoped>
.article_loading {
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.article_body {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}
</style>
